module.exports = __webpack_public_path__ + "static/media/error.0787464b.svg";